import React from "react";
import { CheckCircle } from "lucide-react";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Grow Your Travel Agency Leads Using WhatsApp Effectively",
    points: [
      "Launch click-to-WhatsApp ads featuring special travel offers to attract attention.",
      "Share WhatsApp links on social media and other platforms to boost visibility.",
      "Embed a WhatsApp widget on your website to start conversations instantly.",
      "Send automated welcome messages to engage customers and gather more details.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_1.png",
  },
  {
    heading: "Qualify Travel Leads Quickly with WhatsApp Chats",
    points: [
      "Use smart WhatsApp chatbots to collect information like destinations, budgets, and group sizes.",
      "Connect with your CRM to save customer data and assign top travel agents.",
      "Set up automated replies to answer frequent travel questions effortlessly.",
      "Broadcast new travel deals and packages directly to interested leads on WhatsApp.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_2.png",
  },
  {
    heading: "Streamline Travel Bookings and Payments on WhatsApp",
    points: [
      "Send detailed itineraries and proposals as PDFs through WhatsApp.",
      "Confirm bookings and process payments right within WhatsApp conversations.",
      "Handle custom requests and adjustments for travel packages via chat.",
    ],
    buttonText: "Payments on WhatsApp",
    buttonLink:"https://www.whatsapp.com/payments/in",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_3.png",
  },
  {
    heading: "Make Document Collection Easy with WhatsApp for Travel",
    points: [
      "Create automations to request documents like passports and IDs based on travel plans.",
      "Let customers securely upload files such as COVID certificates on an encrypted platform.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_4.png",
  },
  {
    heading: "Keep Travelers Informed with WhatsApp Updates",
    points: [
      "Automate notifications for booking confirmations and status updates.",
      "Share real-time progress for international trips, including visa statuses.",
      "Allow easy rescheduling or service requests through WhatsApp messages.",
      "Deliver boarding passes and e-tickets directly via WhatsApp for convenience.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for Travel Agency",
    buttonLink:"https://www.facebook.com/business/help/1690794621187911?id=221593351918232",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_5.png",
  },
  {
    heading: "Improve Traveler Experience with WhatsApp Support",
    points: [
      "Offer hotel check-ins and book services like wheelchair assistance via WhatsApp.",
      "Provide options for extra beds, dining reservations, and more through chats.",
    ],
    buttonText: "WhatsApp Support",
    buttonLink:"https://faq.whatsapp.com/854037192262196",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_6.png",
  },
  {
    heading: "Offer Top-Notch Support After Purchase via WhatsApp",
    points: [
      "Resolve issues and take requests using interactive WhatsApp buttons.",
      "Securely gather verification documents from sellers and properties.",
      "Use CRM integration to keep seller records organized and accessible.",
      "Schedule call backs and coordinate with local agents through WhatsApp.",
      "Handle cancellations and refunds efficiently within the chat platform.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_7.png",
  },
  {
    heading: "Build Customer Loyalty with WhatsApp Engagement",
    points: [
      "Ask for feedback and conduct surveys to enhance your services.",
      "Reward happy customers with discounts for referrals.",
      "Encourage enrollment in a loyalty program for exclusive perks.",
      "Make re-booking travel packages simple with regular WhatsApp reminders.",
      "Recommend personalized travel options based on past bookings.",
      "Share the latest news and achievements of your agency via broadcasts.",
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_8.png",
  },
];

// Additional Section Data
const additionalSectionData = {
  heading: "Why WhatsApp Business API Is Perfect for Travel and Tourism",
  description: "WhatsApp brings back personal touch to online sales, helping travel companies connect better with their audience.",
  points: [
    "Provide round-the-clock customer support with available agents.",
    "Automate answers to common travel and tourism questions.",
    "Manage all marketing and engagement on a single, powerful channel.",
    "Understand customer needs better through direct conversations.",
    "Save time for agents by focusing on high-value follow-ups.",
    "Speed up sales with proactive and timely communication.",
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/additionalSection.png",
};


const travelServices = [
  {
    id: 1,
    icon: <span className="text-2xl">✈️</span>, // Airplane icon
    title: "Generate Leads with WhatsApp Ads",
    description: "Launch click-to-WhatsApp ads showcasing irresistible travel deals. It’s like waving a magic wand to attract dream vacationers right to your inbox!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🌍</span>, // Globe icon
    title: "Boost Visibility with WhatsApp Links",
    description: "Share travel package links on social media and your website via WhatsApp. It’s a simple way to get more eyes on your offerings and spark interest."
  },
  {
    id: 3,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Qualify Leads Fast on WhatsApp",
    description: "Use smart chatbots to gather details like destinations, budgets, and group sizes via WhatsApp. You’ll know exactly who’s ready to book in no time!"
  },
  {
    id: 4,
    icon: <span className="text-2xl">📱</span>, // Phone icon
    title: "Engage Customers with Welcome Messages",
    description: "Send automated greetings and follow-ups on WhatsApp to capture leads and build rapport. It’s the first step to turning inquiries into bookings."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Simplify Bookings via WhatsApp",
    description: "Let clients confirm trips, share itineraries, and handle payments all through WhatsApp. It’s a seamless experience that keeps leads coming back."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Nurture Leads with Exclusive Updates",
    description: "Send personalized travel deals, destination tips, and loyalty rewards via WhatsApp. It’s how you turn prospects into lifelong travelers!"
  }
];
const travelFAQs = [
  {
    question: "How can WhatsApp help me generate more travel leads?",
    answer: "WhatsApp can skyrocket your lead generation by sending targeted ads and exclusive deals directly to potential travelers. It’s like having a marketing genius working around the clock to bring dream vacationers to your door!"
  },
  {
    question: "What kind of ads work best on WhatsApp for travel?",
    answer: "Click-to-WhatsApp ads with stunning destination images and limited-time offers work best. They grab attention fast, like a travel brochure that pops up right when someone’s dreaming of a getaway."
  },
  {
    question: "Is WhatsApp secure for sharing travel itineraries?",
    answer: "Yes, WhatsApp’s end-to-end encryption keeps itineraries, bookings, and customer data safe. It’s like locking your travel plans in a vault, so clients can relax knowing their info is protected."
  },
  {
    question: "How do I qualify travel leads using WhatsApp?",
    answer: "Use chatbots to ask about destinations, budgets, and group sizes via WhatsApp. It’s like having a virtual assistant that sorts hot leads from casual browsers in minutes!"
  },
  {
    question: "Can WhatsApp help me book tours for clients?",
    answer: "Absolutely! Clients can confirm trips, review itineraries, and even pay via WhatsApp. It’s like turning a chat into a one-stop travel shop, making bookings effortless."
  },
  {
    question: "How can WhatsApp engage travelers before they book?",
    answer: "Send welcome messages, destination tips, and special offers via WhatsApp. It’s like building excitement and trust from the first hello, turning inquiries into bookings."
  },
  {
    question: "What travel content should I share on WhatsApp?",
    answer: "Share stunning photos, travel guides, and deal alerts via WhatsApp. It’s a direct line to inspire wanderlust and keep your agency top-of-mind for every trip."
  },
  {
    question: "Can WhatsApp reduce my travel agency’s workload?",
    answer: "Yes! Automate responses to common queries and handle bookings via WhatsApp, freeing you up for big-picture strategy. It’s like having an extra team member who never clocks out."
  },
  {
    question: "How do travelers feel about using WhatsApp for bookings?",
    answer: "They love it! Travelers appreciate the speed, convenience, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making travel planning a joy."
  },
  {
    question: "How do I start using WhatsApp for my travel agency?",
    answer: "Begin by setting up WhatsApp Business, creating chat templates for leads and bookings, and integrating with tools like ChatMitra. It’s a simple step to transform your business!"
  },
];

const Cycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-[#075E54] to-[#0a8a70] py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-center text-4xl font-bold text-white">Discover How WhatsApp Can Transform Your Travel Business</h1>
          <div className="mt-6 flex justify-center">
            <span className="w-24 h-1 bg-white rounded-full"></span>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}

        <div className="bg-[#054d40] p-12 rounded-lg mt-20">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white mb-8 text-center">{additionalSectionData.heading}</h2>
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="w-full lg:w-1/2">
                <p className="text-lg text-white mb-6">{additionalSectionData.description}</p>
                <ul className="space-y-4 text-white">
                  {additionalSectionData.points.map((point, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle className="text-green-400 w-5 h-5 flex-shrink-0" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="w-full lg:w-1/2">
                <img src={additionalSectionData.image} alt="WhatsApp Benefits" className="w-full h-auto rounded-lg " />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const TravelLeadSection = () => {
  const travelLeadData = {
    heading: "Drive More Leads for Your Travel Agency with WhatsApp Solutions",
    points: [
      "Offer non-stop customer support and ensure agents are always reachable.",
      "Automate responses to common travel and tourism inquiries.",
      "Distribute important documents, PDFs, and brochures via WhatsApp.",
    ],
    buttons: [
      { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]",buttonLink:"https://app.chatmitra.com/signin", },
      { text: "Request a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
    ],
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_hero.png",
  };

  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">{travelLeadData.heading}</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                 <a
                 key={index}
                 href={button.buttonLink}
                 className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
               >
                 {button.text}
               </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Travel Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>
      </section>

      <Cycle />
      
      <WhatsAppServices servicesData={travelServices} isVisible={true}/>
      <Faqs faqs={travelFAQs} />

      
      <title>Enhance Your Travel Business with WhatsApp | ChatMitra</title>
      <meta name="description" content="Boost your travel agency’s lead generation, automate inquiries, and manage bookings using WhatsApp. Discover how ChatMitra can help you excel." />
      <meta name="keywords" content="WhatsApp for travel and tourism, travel lead generation, travel agency marketing, WhatsApp automation, customer support, ChatMitra" />
      <meta property="og:title" content="Enhance Your Travel Business with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to generate leads, automate travel queries, and provide outstanding support for your travel agency with ChatMitra." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-travel-and-tourism" />
      <meta property="og:type" content="website" />
      <Footer />
    </>
  );
};

export default TravelLeadSection;



